module.exports = __webpack_public_path__ + "img/features-cloud.60b884dc.png";